<div class="container">
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div class="bottom-arrow"></div>
</div>
